import { defineFcm } from '../shared/factory';

export const FCM_PROMOTE_FORM_TAX_LANGUAGE_SUPPORT_ENABLED = defineFcm('promote_form_tax_language_support_enabled')
	.asBoolean()
	.withDefault(false)
	.toConfig();
